let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eDVt1")).then(() => parcelRequire('49xmL'));